export default __webpack_public_path__ + "static/bn-43328fe6ecf986eab3fecf82b8265b78.svg";